import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAr: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAr"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5V20H8.37574L12 16.8288L15.6243 20H23V5H1ZM7.5 9.25C6.25736 9.25 5.25 10.2574 5.25 11.5C5.25 12.7426 6.25736 13.75 7.5 13.75C8.74264 13.75 9.75 12.7426 9.75 11.5C9.75 10.2574 8.74264 9.25 7.5 9.25ZM14.25 11.5C14.25 10.2574 15.2574 9.25 16.5 9.25C17.7426 9.25 18.75 10.2574 18.75 11.5C18.75 12.7426 17.7426 13.75 16.5 13.75C15.2574 13.75 14.25 12.7426 14.25 11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAr;
